import { useId } from "react";
import { useSignal } from "~/sdk/signal";
import { ReactNode } from "react";
import { useEffect } from "react";

interface Props {
  onClose?: () => void;
  open?: boolean;
  className?: string;
  loading?: "eager" | "lazy";
  children: ReactNode;
  aside: ReactNode;
}

function Drawer(props: Props) {
  const {
    children,
    aside,
    open,
    onClose,
    className: _class = "",
    loading = "lazy",
  } = props;
  const lazy = useSignal(loading === "lazy" && !open);
  const id = useId();

  useEffect(() => {
    const handler = (e: KeyboardEvent) =>
      (e.key === "Escape" || e.keyCode === 27) && open && onClose?.();

    addEventListener("keydown", handler);

    return () => {
      removeEventListener("keydown", handler);
    };
  }, [open]);

  useEffect(() => {
    lazy.value = false;
  }, []);

  return (
    <div className={`drawer ${_class}`}>
      <input
        id={id}
        checked={open}
        type="checkbox"
        className="drawer-toggle"
        aria-label="Expandir ou retrair"
        onChange={(e) => e.currentTarget.checked === false && onClose?.()}
      />

      <div className="drawer-content">{children}</div>

      <aside className="drawer-side h-full z-[100]">
        <label htmlFor={id} className="drawer-overlay" />
        {!lazy.value && aside}
      </aside>
    </div>
  );
}

export default Drawer;
